import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "logo-w" }
const _hoisted_2 = ["src"]

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Logo',
  setup(__props) {

const tenantKey = process.env.VUE_APP_TENANT_KEY

const logoSrc = computed(() => {
  switch (tenantKey) {
    case 'bsg':
      return require('@/assets/img/bsg-logo.png')

    case 'bbq':
      return require('@/assets/img/bbq-logo.png')

    default:
      return require('@/assets/img/default-logo.png')
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: logoSrc.value,
      class: "w-100"
    }, null, 8, _hoisted_2)
  ]))
}
}

})